import { TYPES } from './types';
import { projectService } from '../services';

// Get all projects
export const getProjects = () => async dispatch => {
  try {
    const res = await projectService.getProjects();
    dispatch({
      type: TYPES.ACTION_GET_PROJECTS_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_PROJECTS_FAIL,
      payload: err.response?.data || { message: 'Error getting projects' }
    });
  }
};

// Get single project
export const getProject = (id) => async dispatch => {
  try {
    const res = await projectService.getProject(id);
    dispatch({
      type: TYPES.ACTION_GET_PROJECT_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_PROJECT_FAIL,
      payload: err.response?.data || { message: 'Error getting project' }
    });
  }
};

// Create project
export const createProject = (projectData) => async dispatch => {
  try {
    const res = await projectService.createProject(projectData);
    dispatch({
      type: TYPES.ACTION_CREATE_PROJECT_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_CREATE_PROJECT_FAIL,
      payload: err.response?.data || { message: 'Error creating project' }
    });
  }
};

// Update project
export const updateProject = (id, projectData) => async dispatch => {
  try {
    const res = await projectService.updateProject(id, projectData);
    dispatch({
      type: TYPES.ACTION_UPDATE_PROJECT_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_UPDATE_PROJECT_FAIL,
      payload: err.response?.data || { message: 'Error updating project' }
    });
  }
};

// Delete project
export const deleteProject = (id) => async dispatch => {
  try {
    await projectService.deleteProject(id);
    dispatch({
      type: TYPES.ACTION_DELETE_PROJECT_SUCCESS,
      payload: id
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_DELETE_PROJECT_FAIL,
      payload: err.response?.data || { message: 'Error deleting project' }
    });
  }
}; 

export const projectAction = {
  getProjects,
  getProject,
  createProject,
  updateProject,
  deleteProject
};